import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-docu-sent',
  templateUrl: './docu-sent.component.html',
  styleUrls: ['./docu-sent.component.css']
})
export class DocuSentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
